import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PercentageLoadingService } from 'src/app/shared/percentage-loading/percentage-loading.service';
import { PreOrder } from 'src/app/shared/models/pre-order.model';
import { PreOrderDataType } from 'src/app/shared/enums/pre-order-data-type.enum';
import { ColumnsMeta } from 'projects/dop-table/src/lib/models/columns-meta.model';
import { TableMeta } from 'projects/dop-table/src/lib/models/table-meta.model';
import { Sample } from 'src/app/shared/models/sample.model';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { OrderSetupService } from './order-setup.service';
import { OrderSetupContext } from '../../shared/models/order-creation/order-setup.context';
import { OrderSetupType } from 'src/app/shared/enums/order-setup-type.enum';
import { StoreService } from 'projects/dop-core/src/lib/store/ngrx-store.service';
import { StoreKey } from 'src/app/core/store/ngrx-store.keys';
import { UserDetails } from 'src/app/shared/models/user-details.model';
import { UserType } from 'src/app/shared/enums/user-type.enum';
import { LabType } from 'src/app/shared/enums/lab-type.enum';
import { TranslationService } from 'projects/dop-core/src/public-api';
import { alphaNumeric } from 'src/app/shared/validators/alphanumeric.validators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OrderStateChangeEnum } from 'src/app/shared/enums/order-state-change.model';
import { OrderState } from 'src/app/shared/enums/order-state.enum';
import { SwitchStepService } from 'src/app/core/services/switch-step.service';
import { CurrentOrderService } from 'src/app/shared/services/current-order.service';
import { EolctDataService } from 'src/app/shared/data-service/eolct-data.service';
import { LabsiteCheckService } from 'src/app/shared/labsite-check/labsite-check.service';
import { RequestResponseService } from 'src/app/shared/services/request-response.service';

@Component({
  selector: 'app-order-setup',
  templateUrl: './order-setup.component.html',
  styleUrls: ['./order-setup.component.scss']
})
export class OrderSetupComponent implements OnInit, OnChanges {

  @Input() showDialog: boolean;
  @Input() createFromPrevious: boolean;
  @Input() orderState: OrderState;
  @Output() closeEvent = new EventEmitter();

  position: 'top';
  orderSetupContext: OrderSetupContext;
  orderSetupType: OrderSetupType = OrderSetupType.NONE;
  preOrderDataType: PreOrderDataType = PreOrderDataType.LIST;

  abstractPopUp: boolean;
  headerTitle: string;
  options: SelectItem[];
  selectedOption: '';
  showFooter: false;
  canGoBack: boolean;
  labType: any;
  showQuotationSelectionPopup: boolean = false;
  showContractSelectionPopup: boolean = false;
  quotationSelectionResult: any = null;
  contractSelectionResult: any = null;

  MAX_LIMIT = 5;
  preOrder: PreOrder = new PreOrder();

  tableMeta: TableMeta = {
    displayGlobalSearch: true,
    displayCheckBox: true,
    hidePagination: false
  };

  cols: ColumnsMeta[] = [];
  samples: Sample[] = [];
  totalRecords = 0;
  disableGrid = false;
  isDataLoaded = false;
  OrderSetupType = OrderSetupType;
  isInternalUser: boolean;
  directToStep1 = false;
  orderNameForm: FormGroup;

  constructor(
    private router: Router,
    private orderSetupService: OrderSetupService,
    private storeService: StoreService,
    private fb: FormBuilder,
    private switchStepService: SwitchStepService,
    private currentOrderService: CurrentOrderService,
    private eolCtDataService: EolctDataService,
    private labsiteCheck: LabsiteCheckService,
    private requestResponseService: RequestResponseService,
    private percentageLoadingService: PercentageLoadingService
  ) {
    this.abstractPopUp = false;
    this.requestResponseService.request$.subscribe(request => {
      console.log('Received request:', request);
      if (request.id === 'request-quotation-selection') {
        this.manualSelectionOfQuotationByUserDuringClone(request).then(selection => this.requestResponseService.sendResponse(request.id, selection));
      }
      else if (request.id === 'request-contract-selection') {
        this.manualSelectionOfContractByUserDuringClone(request).then(selection => this.requestResponseService.sendResponse(request.id, selection));
      }
    })
  }
  private async manualSelectionByUserDuringClone(
    request: any,
    type: OrderSetupType,
    headerKey: string,
    showPopupFlag: 'showQuotationSelectionPopup' | 'showContractSelectionPopup',
    selectionResultProp: 'quotationSelectionResult' | 'contractSelectionResult',
    selectionHandlerProp: 'onQuotationSelection' | 'onContractSelection',
    loadData?: () => Promise<void>
  ): Promise<any> {
  this.percentageLoadingService.setVisible(true);
    this.orderSetupType = type;
    this.headerTitle = TranslationService.translate(headerKey);

    if (loadData) {
      await loadData();
    }
  this.percentageLoadingService.setVisible(false);
    this.showDialog = true;
    this[showPopupFlag] = true;

    return new Promise(resolve => {
      const handler = (event: any) => {
        this[selectionResultProp] = event;
        this.showDialog = false;
        this[showPopupFlag] = false;
  this.percentageLoadingService.setVisible(true);
        resolve(event);
        this[selectionHandlerProp] = originalHandler;
      };
      const originalHandler = this[selectionHandlerProp].bind(this);
      this[selectionHandlerProp] = handler;
    });
  }

  async manualSelectionOfQuotationByUserDuringClone(request: any): Promise<any> {
    this.abstractPopUp = true;
    this.orderSetupContext.masterData.quotations = undefined;
    return this.manualSelectionByUserDuringClone(
      request,
      OrderSetupType.QUOTATION,
      'vbeiSelectQuotation',
      'showQuotationSelectionPopup',
      'quotationSelectionResult',
      'onQuotationSelection',
      async () => {
        if (!this.orderSetupContext.masterData?.quotations) {
          await this.orderSetupService.loadQuotations(request.payload.accountCode);
        }
      }
    );
  }

  async manualSelectionOfContractByUserDuringClone(request: any): Promise<any> {
    this.abstractPopUp = true;
    return this.manualSelectionByUserDuringClone(
      request,
      OrderSetupType.CONTRACT,
      'vbeiSelectContract',
      'showContractSelectionPopup',
      'contractSelectionResult',
      'onContractSelection',
      async () => {
            this.headerTitle = TranslationService.translate('vbeiSelectContract');
            this.orderSetupContext.masterData.contracts = request.payload.contracts;
      }
    );
  }

  async ngOnInit() {
    this.orderSetupContext = this.orderSetupService.getContext();
    const userDetails = await this.storeService.Get<UserDetails>(StoreKey[StoreKey.UserDetails]).toPromise();
    this.isInternalUser = userDetails.profile.userType.toString().toLowerCase() !== UserType[0].toString().toLowerCase();
    this.MAX_LIMIT += (this.createFromPrevious) ? 1 : 0;
    this.orderNameForm = this.fb.group({
      OrderName: ['', alphaNumeric()],
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.orderState) {
      if (this.orderState === OrderState.New) {
        await this.onNewOrder();
      }
    }
  }

  async onNewOrder() {
    this.directToStep1 = await this.orderSetupService.selectAllSingleFields();
    if (this.directToStep1) {
      this.showDialog = false;
      this.continueOrder();
    }
    this.orderSetupContext = this.orderSetupService.getContext();
    this.moveForward(true);
  }

  onAccountSelection(event: any) {
    if (this.orderSetupContext.transactionalData?.account.code !== event.code) {
      this.orderSetupService.resetContextOnAccountChange();
    }
    this.orderSetupContext.transactionalData.account = event;
    this.moveForward(true);
  }

  onOrderTemplateSelection(event: any) {
    this.orderSetupContext.transactionalData.orderTemplate = event;
    this.getStandardCommentTemplates();
    this.orderSetupService.saveOrderingTemplateInStore(this.orderSetupContext.transactionalData?.orderTemplate);
    this.moveForward(true);
  }

  onQuotationSelection(event: any) {
    if (this.orderSetupContext.transactionalData?.quotation.code !== event.code) {
      this.orderSetupContext.transactionalData.contract = {};
      this.orderSetupContext.masterData.contracts = undefined;
    }
    this.orderSetupContext.transactionalData.quotation = event;
    this.moveForward(true);
  }

  noContractAvailable() {
    this.moveForward(false);
  }

  onContractSelection(event: any) {
    this.orderSetupContext.transactionalData.contract = event;
    this.moveForward(true);
  }

  get orderStep() {
    return OrderSetupType;
  }

  onDataSelect(event: any) {
    if (event.originalEvent.srcElement.tagName !== 'A') {
      this.moveForward(true);
    }
  }

  onSwitchToStep(step: number) {
    this.orderSetupType = step;
    if (step !== -1
      && (this.orderSetupContext.transactionalData?.stateChange === OrderStateChangeEnum.NoChange
        || this.orderSetupContext.transactionalData?.stateChange > step + 1)) {
      this.orderSetupContext.transactionalData.stateChange = step + 1;
    }
    this.continueOrder();
  }

  async moveForward(forward: boolean) {
    const metrix = (forward) ? 1 : this.getBackButtonMetric();
    const maxLimit = (forward) ? this.MAX_LIMIT : 0;
    this.orderSetupType += (this.orderSetupType === maxLimit) ? 0 : metrix;
    if (this.orderSetupContext.transactionalData?.orderState !== OrderState.New) {
      this.canGoBack = this.orderSetupType > 3 && this.orderSetupContext.masterData?.quotations.length > 1;
    } else {
      this.canGoBack = (this.orderSetupType > 1 && this.orderSetupType <= this.MAX_LIMIT);
    }

    switch (this.orderSetupType) {
      case OrderSetupType.ACCOUNT:
        this.headerTitle = TranslationService.translate('vbeiSelectAccount');
        if (this.orderSetupContext.masterData?.accounts.length === 0 && !this.isInternalUser) {
          this.orderSetupService.loadAccounts()
            .then(() => this.handleSingleSelection(this.orderSetupContext.masterData?.accounts, OrderSetupType.ACCOUNT, forward));
        }
        break;
      case OrderSetupType.ORDERTEMPLATE:
        this.headerTitle = TranslationService.translate('vbeiSelectOrderingService');
        if (!this.orderSetupContext.masterData?.orderTemplates) {
          await this.orderSetupService.loadOrderTemplate(this.orderSetupContext.transactionalData?.account.code);
        }
        this.handleSingleSelection(this.orderSetupContext.masterData?.orderTemplates, OrderSetupType.ORDERTEMPLATE, forward);
        if (this.orderSetupContext.masterData?.orderTemplates.length === 1) {
          this.getStandardCommentTemplates();
          this.orderSetupService.saveOrderingTemplateInStore(this.orderSetupContext.transactionalData?.orderTemplate);
        }
        break;
      case OrderSetupType.QUOTATION:
        this.headerTitle = TranslationService.translate('vbeiSelectQuotation');
        if (!this.orderSetupContext.masterData?.quotations) {
          await this.orderSetupService.loadQuotations(this.orderSetupContext.transactionalData?.account.code);
        }
        if (this.orderSetupContext.masterData?.quotations) {
          this.handleSingleSelection(this.orderSetupContext.masterData?.quotations, OrderSetupType.QUOTATION, forward);
          this.orderSetupService.handleDefaultQuotationSelection();
        }
        break;
      case OrderSetupType.CONTRACT:
        this.orderSetupService.setEleInterEleCode(this.orderSetupContext);
        this.labType = await this.orderSetupService.getLabType(this.orderSetupContext.transactionalData?.quotation.receivingLabCode);
        if (!(this.orderSetupContext.masterData?.contracts && this.orderSetupContext.masterData?.contracts.length > 0)) {
          if (await this.labsiteCheck.isElimsOrTransitionedToElims(this.orderSetupContext.transactionalData?.quotation.receivingLabCode, this.labType,
            this.orderSetupContext.transactionalData?.account.code)) {
            this.headerTitle = TranslationService.translate('vbeiSelectContract');
            await this.orderSetupService.loadContract(this.orderSetupContext.transactionalData?.account.code,
              this.orderSetupContext.transactionalData?.quotation.code);
          } else {
            await this.orderSetupService.loadExternalLimsAccounts(this.orderSetupContext.transactionalData?.account.code);
          }
        }
        if (this.orderSetupContext.masterData?.contracts) {
          this.headerTitle = TranslationService.translate('vbeiSelectContract');
          this.handleSingleSelection(this.orderSetupContext.masterData?.contracts, OrderSetupType.CONTRACT, forward);
          this.orderSetupService.handleDefaultContractSelection();
        }
        break;
      case OrderSetupType.ORDERNAME:
        this.headerTitle = TranslationService.translate('vbeiEnterOrderName');
        break;
    }
  }

  getBackButtonMetric(): number {
    let backMetric = -1;
    switch (this.orderSetupType) {
      case OrderSetupType.QUOTATION:
        if (this.orderSetupContext.masterData?.orderTemplates.length === 1) {
          backMetric -= 1;
        }
        break;
      case OrderSetupType.CONTRACT:
        this.backTraverse(backMetric);
        break;
      case OrderSetupType.ORDERNAME:
        if (this.orderSetupContext.masterData?.contracts && this.orderSetupContext.masterData?.contracts.length > 1) {
          this.backTraverse(backMetric);
        } else {
          backMetric -= 1;
          this.backTraverse(backMetric);
        }
        break;
    }
    return backMetric;
  }

  backTraverse(backMetric: number) {
    if (this.orderSetupContext.masterData?.quotations.length === 1) {
      backMetric -= 1;
      if (this.orderSetupContext.masterData?.orderTemplates.length === 1) {
        backMetric -= 1;
      }
    }
  }

  async continueOrder(fromSubmittedOrders = false, isAnalysesRelatedError = false) {
    if (this.orderSetupType === this.MAX_LIMIT || this.directToStep1) {
      this.showDialog = false;
      if (this.orderSetupContext.transactionalData?.orderState !== OrderState.New && !fromSubmittedOrders) {
        await this.checkOtherOrderValidation();
      }
      if (!fromSubmittedOrders) {
        this.currentOrderService.reset();
      }

      this.currentOrderService.isSomeOrAllInvoiceableItemsAreRemoved = isAnalysesRelatedError;

      if ((this.orderSetupContext.transactionalData?.OrderCode
        && this.orderSetupContext.transactionalData?.OrderReference === undefined)
        || this.orderSetupContext.transactionalData?.sampleGlcError) {
        return;
      }

      this.orderSetupService.setCurrentOrderContext(this.orderSetupContext);
      await this.router.navigate(['/guidedOrder']);
      await this.router.navigate([{ outlets: { primary: 'guidedOrder', guidedOrderRoute: 'samples' } }]);
      this.switchStepService.reloadSampleInitData();
    } else {
      this.moveForward(true);
    }
  }

  async checkOtherOrderValidation() {
    this.orderSetupService.validateOrderNameChangeAndSave();
    switch (this.orderSetupContext.transactionalData?.stateChange) {
      case OrderStateChangeEnum.QuotationChange:
        await this.orderSetupService.validateNewLabs();
        await this.orderSetupService.updateQuotationContract();
        break;
      case OrderStateChangeEnum.ContractChange:
        if (this.orderSetupContext.transactionalData?.orderState !== OrderState.Pending) {
          await this.orderSetupService.createOrderWithSamples(true);
        }
        await this.orderSetupService.updateQuotationContract();
        break;
      default: break;
    }
  }

  onClose() {
    this.closeEvent.emit();
  }

  handleSingleSelection(options: any, transactionalProp: OrderSetupType, forward: boolean) {
    if (options.length === 1) {
      const propName = Object.keys(this.orderSetupContext.transactionalData)
        .filter(key => key.toLowerCase() === OrderSetupType[transactionalProp].toLowerCase()).shift();
      this.orderSetupContext.transactionalData[propName] = options[0];
      this.moveForward(forward);
    }
  }

  changeOrderName(orderName: string) {
    this.orderSetupContext.transactionalData.OrderName = orderName;
  }

  canContinue() {
    if (this.orderSetupContext && this.orderSetupType !== OrderSetupType.ORDERNAME) {
      const propName = Object.keys(this.orderSetupContext.transactionalData)
        .filter(key => key.toLowerCase() === OrderSetupType[this.orderSetupType as number].toLowerCase()).shift();
      if (propName && this.orderSetupContext.transactionalData[propName].code) {
        return true;
      }
    }
    if (this.orderSetupType === OrderSetupType.ORDERNAME && this.orderNameForm.valid) {
      return true;
    }
  }

  setUpOrderContext(orderSetupContext: OrderSetupContext) {
    this.orderSetupService.setContext(orderSetupContext);
    this.orderSetupContext = orderSetupContext;
  }

  loadAddSamplesPage() {
    this.orderSetupContext.transactionalData.orderState = OrderState.New;
    this.directToStep1 = true;
    this.continueOrder();
  }
  getStandardCommentTemplates() {
    const orderTemplate = this.orderSetupContext.transactionalData?.orderTemplate;
    if (orderTemplate.structuredComment && orderTemplate.structuredComment.toLowerCase() !== 'none') {
      this.eolCtDataService.getCommerialItemStandardComments(orderTemplate.structuredComment).subscribe((data) => {
        if (data) {
          this.orderSetupContext.transactionalData.standardCommentTemplate = data;
        }
      });
    }
  }



}
